import { AbstractModel } from '@/models/abstractModel';
import type { ICustomLeagueApi } from '@/types/customLeaguePage';

export class CustomLeagueItem extends AbstractModel {
    public ageCategoryId: number | null = null;
    public categoryId: number | null = null;
    public chgroupId: number = 0;
    public chtrade: number = 0;
    public countryId: number | null = null;
    public createdAt: string = '';
    public deletedAt: string | null = null;
    public fixing: 0 | 1 = 0;
    public gender: number | null = null;
    public id: number = 0;
    public isUseTradeball: number = 0;
    public isUseWl: number = 0;
    public limitsCategoryId: number | null = null;
    public marketCategoryId: number | null = null;
    public minute: number = 90;
    public name: string = '';
    public notrade: number = 0;
    public rank: number | null = null;
    public sportId: number = 0;
    public tier: number | null = null;
    public updatedAt: string = '';
    public wikiLink: string | null = null;

    constructor(data?: ICustomLeagueApi) {
        super();

        if (!data) {
            return;
        }

        this.id = data.id;
        this.sportId = data.sport_id;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at;
        this.deletedAt = data.deleted_at;
        this.name = data.name;
        this.minute = data.minute;
        this.categoryId = data.category_id;
        this.countryId = data.country_id;
        this.ageCategoryId = data.age_category_id;
        this.gender = data.gender;
        this.limitsCategoryId = data.limits_category_id;
        this.wikiLink = data.wiki_link;
        this.rank = data.rank;
        this.tier = data.tier;
        this.isUseTradeball = data.is_use_tradeball;
        this.isUseWl = data.is_use_wl;
        this.fixing = data.fixing;
        this.marketCategoryId = data.market_category_id;
        this.chtrade = data.chtrade;
        this.notrade = data.notrade;
        this.chgroupId = data.chgroup_id;
    }

    get hasWikiLink(): boolean {
        return !!this.wikiLink && this.wikiLink.trim() !== '';
    }

    get isFixing(): boolean {
        return this.fixing === 1;
    }

    toApiData(): Record<string, unknown> {
        const isCreate = this.id <= 0;
        const row: Record<string, unknown> = {
            name: this.name.trim(),
            minute: this.minute,
            gender: this.gender,
            age_category_id: this.ageCategoryId,
            limits_category_id: this.limitsCategoryId,
            fixing: this.fixing,
            country_id: this.countryId,
            category_id: this.categoryId,
            market_category_id: this.marketCategoryId,
            rank: this.rank,
            tier: this.tier,
            wiki_link: this.wikiLink?.trim() || null,
        };

        if (isCreate) {
            row.sport_id = this.sportId;
        } else {
            row.id = this.id;
        }

        return row;
    }
}
